<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <ReiseterminCardAufgaben :reiseterminObj="reiseterminObj"></ReiseterminCardAufgaben>
      </div>

      <div class="col-md-12">
        <ReiseterminViewCardSheetdata :reiseterminObj="reiseterminObj" />
      </div>

      <div class="col-md-8">
        <ReiseterminViewCardVorgaenge
          v-if="reiseterminObj"
          :reiseterminObj="reiseterminObj"
          :setMaxHeight="true"
          @update-single-item="$emit('updated-vorgang', $event)"
        ></ReiseterminViewCardVorgaenge>
        <div v-if="!reiseterminObj" class="card card-custom">
          <div class="card-header">
            <b-skeleton class="m-auto" height="100%" width="100%"></b-skeleton>
          </div>
          <div class="card-body">
            <b-skeleton-table :rows="8" :columns="6"></b-skeleton-table>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <template v-if="reiseterminObj">
          <ReiseterminComments
            :reiseterminId="reiseterminObj.id"
            :comments="getCommentsWithMappedAnswers"
            :showDepartmentButtons="true"
            :departmentsOfCommentCreators="departmentsOfCommentCreators"
            :selectedDepartment="selectedDepartment"
            @updateComments="onUpdateComments"
            @changeDepartment="changeDepartment"
            :hideEmojis="true"
            :maxHeight="850"
          />
        </template>
        <template v-else>
          <div class="card">
            <div class="card-header">
              <b-skeleton class="m-auto" height="100%" width="100%"></b-skeleton>
            </div>
            <div class="card-body">
              <b-skeleton class="m-auto" height="200px" width="100%"></b-skeleton>
            </div>
          </div>
        </template>
      </div>

      <div class="col-md-12">
        <ReiseterminViewReleasepruefungCard
          :reiseterminObj="reiseterminObj"
          :isReiseterminInReleasePruefung="isReiseterminInReleasePruefung || isInTransferplanung"
          :isInTransferplanung="isInTransferplanung"
          :gueltigeKonfiguration="reiseterminObj?.gueltigeKonfiguration"
          @releaseprocess-updated="$emit('releaseprocess-updated', $event)"
        ></ReiseterminViewReleasepruefungCard>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.more-btn {
  cursor: pointer;
}
</style>

<script>
import ReiseterminViewCardSheetdata from '@/components/produkte/reisetermine/reisetermin-card-sheetdata.vue';
import ReiseterminViewCardVorgaenge from '@/components/produkte/reisetermine/reisetermin-card-vorgaenge.vue';
import ReiseterminCardAufgaben from '@/components/produkte/reisetermine/reisetermin-card-aufgaben.vue';
import ReiseterminViewReleasepruefungCard from '@/components/produkte/reisetermine/reisetermin-view-releasepruefung-card.vue';
import { mapState } from 'vuex';
import { filterCommentsByDepartment, departmentButtonClass } from '@/core/common/helpers/utils';
import ReiseterminComments from '@/components/comments/reisetermin-comments.vue';

export default {
  name: 'ReisetermineViewComponent',
  components: {
    ReiseterminViewCardVorgaenge,
    ReiseterminViewCardSheetdata,
    ReiseterminCardAufgaben,
    ReiseterminViewReleasepruefungCard,
    ReiseterminComments,
  },
  props: {
    reiseterminObj: Object,
  },
  data() {
    return {
      selectedDepartment: null,
    };
  },
  computed: {
    ...mapState({
      users: state => state.users['users'],
    }),
    filteredComments() {
      return filterCommentsByDepartment(this.reiseterminObj?.comments, this.selectedDepartment, this.users);
    },
    departmentsOfCommentCreators() {
      // überprüfung, ob das comments array leer ist
      if (this.reiseterminObj?.comments?.length === 0) {
        return [];
      } else {
        // es werden sich alle creator aus den kommentaren geholt -> geht über das gesamte array von Objects
        // ergebnis ist ein neues array mit den IDs
        const creatorIds = this.reiseterminObj?.comments.map(comment => comment.creator);

        // geht über das users Array und überprüft, ob die ID in dem creators array enthalten ist
        const usersList = this.users.filter(user => creatorIds.includes(user.id));

        // geht über jedes usersList array und nimmt sich da dann das department heraus
        const departments = usersList.map(user => user.department);
        // Dedupliziert den department button, wenn ein Reisetermin "Customer Operations- und Success Management" kommentare hat
        const geseheneLabels = new Set();
        return departments.filter(department => {
          const label = departmentButtonClass(department).label ?? department;
          if (geseheneLabels.has(label)) {
            return false;
          }
          geseheneLabels.add(label);
          return true;
        });
      }
    },
    getCommentsWithMappedAnswers() {
      if (!this.reiseterminObj || !this.reiseterminObj.comments?.length > 0) {
        return [];
      }

      const answers = this.filteredComments.filter(comment => comment.parentId !== null);
      const commentsWithAnswers = this.filteredComments
        .filter(comment => comment.parentId === null)
        .map(comment => {
          const matchingAnswers = answers.filter(answer => answer.parentId === comment.id);
          if (matchingAnswers.length > 0) {
            return { ...comment, answers: matchingAnswers };
          } else return { ...comment, answers: [] };
        })
        .sort((a, b) => new Date(b.createdDateUtc) - new Date(a.createdDateUtc));
      return commentsWithAnswers;
    },
    isTerminNach24() {
      if (!this.reiseterminObj) {
        return false;
      }
      return new Date(this.reiseterminObj.startdatum).getFullYear() === 2025;
    },
    isReiseterminInReleasePruefung() {
      return this.reiseterminObj?.state === 'Aufgelegt';
    },
    isInTransferplanung() {
      return this.reiseterminObj?.state === 'Aufgelegt';
    },
  },
  methods: {
    onUpdateComments(res) {
      this.reiseterminObj.comments = res.comments;
    },
    changeDepartment(departmentLabel) {
      this.selectedDepartment = this.selectedDepartment === departmentLabel ? null : departmentLabel;
    },
  },
};
</script>
